






























import { Component, Vue } from "vue-property-decorator";
import { Action, State, Getter, Mutation } from "vuex-class";
import TransactionItem from "./TransactionItem.vue";
import { Transaction } from "@foxone/api/src/models/defi";

@Component({
  components: {
    TransactionItem
  }
})
class TransactionList extends Vue {
  @State(state => state.defi.transactions.hasNext) hasNext;

  @Getter("defi/transactions/getGroupedSnapshots") groupedTransactions;

  @Mutation("defi/transactions/REMOVE_TRANSACTIONS") removeTransactions;

  @Action("defi/transactions/loadTransactions") loadTransactions;

  loading = false;

  get loadMoreDisabled() {
    return this.loading || !this.hasNext;
  }

  get keys() {
    return Object.keys(this.groupedTransactions).sort((a, b) =>
      a > b ? -1 : 1
    );
  }

  mounted() {
    this.loadData(true);
  }

  async loadData(reload) {
    if (this.loading) {
      return;
    }
    this.loading = true;
    await this.loadTransactions({ reload });
    this.loading = false;
  }

  beforeDestroy() {
    this.removeTransactions();
  }

  handleToTransaction(transaction: Transaction) {
    this.$helper.toFusionPath(this, "defi", {
      name: "transactions-id",
      params: { id: transaction.id }
    });
  }
}
export default TransactionList;
